import React from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import CarRentersTable from "./CarRentersTable"


export default function CarRentersList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Car Renters")} />
        <CarRentersTable />
      </div>
    </div>
  )
}
